import { Typography } from '@mui/material';
import { ReactElement } from 'react';

interface BarChartXAxisLabelProps {
  label: string | number | ReactElement;
}

export const BarChartXAxisLabel = ({ label }: BarChartXAxisLabelProps) => {
  return (
    <Typography
      data-role="bar-chart-x-axis-label"
      variant="caption"
      color="text.secondary"
      textAlign="center"
    >
      {label}
    </Typography>
  );
};
